import React from "react";

const LoaderComp = () => {
  return (
    <div>
      {" "}
      <section className="loadingHere">
        <div className="loader">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </section>
    </div>
  );
};

export default LoaderComp;
